const validationHu = {
    "required": "A mező kitöltése kötelező",
    "min_value": "A mező értéke nem lehet kisebb, mint {{value}}",
    "max_value": "A mező értéke nem lehet nagyobb, mint {{value}}",
    "date_before_today": "A dátum nem lehet a mai nap előtt",
    "date_order": "A kezdés idejének a befejezés ideje előtt kell lennie",
    "event_duration_too_long": "Az esemény hossza nem lehet 24 óra vagy több (max. 23:59)",
    "event_id_taken": "Már létezik egy esemény ezzel az azonosítóval",
    "invalid_phone": "Érvénytelen telefonszám",
    "table_removed_for_overlap": "Asztalok kerültek eltávolításra a foglalásról, mert átfedésbe kerültek már meglévő foglalásokkal: {{tables}}",
    "not_enough_seats": "A vendégek száma ({{guests}}) magasabb, mint az asztalok ülőhelyeinek száma: {{seats}}.",
    "invalid_email_for_guest": "A vendégnek nincs érvényes email címe",
    "invalid_url": "Érvénytelen URL",
    "invalid_email": "Érvénytelen email cím",
}

export default validationHu;